import React from "react";
import Countdown from "react-countdown";
const CountdownDevil = (props) => {
  const renderer = ({ days, hours, minutes, seconds }) => {
    if (days === 0) {
      days = ``;
    } else {
      days = `${days} วัน`;
    }

    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    return (
      <span className="text-xs font-bold">
        {props.group !== "Yeekee"
          ? `${days} ${hours}:${minutes}:${seconds}`
          : "เปิดรับแทง"}
      </span>
    );
  };
  return (
    <Countdown
      renderer={renderer}
      zeroPadTime={2}
      icon={props.icon}
      date={new Date(props.closeSale).getTime()}
    />
  );
};

export default CountdownDevil;
